import api from "@/api";
import request from "@/utils/request";
import axios from "axios";
import CryptoJs from "crypto-js";

import {useJsonStore} from "@/store/jsonStore";
import {useInfoStore} from "@/store";
import {needAllIn, setJsonUrl,getVolunteerPermissions,needThreeIn} from "@/utils/publicMethonds.js";
import {ElLoading} from "element-plus";
const httpJson = axios.create({
    timeout: 300000, // 请求超时时间
});
let loadingTimeout; // 用于控制 loadingInstance 超时

const showLoading = () => {
  const userInfo = useInfoStore()
    userInfo.setKey('loading', true)
};

const hideLoading = () => {
    const userInfo = useInfoStore()
    userInfo.setKey('loading', false)
};
// 请求拦截器
httpJson.interceptors.request.use(
    (config) => {
        if (!config.url.includes('notice.json') &&config.needLoading) {
            showLoading();
        }
        if (loadingTimeout) {
            clearTimeout(loadingTimeout);
        }
        loadingTimeout = setTimeout(() => {
            hideLoading();
        }, 500);
        return config; // 返回请求配置
    },
    (error) => {

        return Promise.reject(error);
    }
);
export const MappingBaseInfoKey = (obj = {}) => {
    const obj_1 = {
        "name": obj.name || '',
        "userId": obj?.userId || '',
        "base_user_id": obj?.userId || '',
        "can_update": obj.can_update || '',
        "agent_id": obj.agent_id || '',
        "teacher_id": obj.teacher_id || '',
        "private_teacher_id": obj.private_teacher_id || '',
        "score": obj?.score || '',
        "show_score": obj?.show_score || '',
        "precedence": obj.precedence || '',
        "buy_report_times": obj.buy_report_times || '',
        "xiugai_fenshu": obj.xiugai_fenshu || '',
        "kaitong_tiyan_vip": obj.kaitong_tiyan_vip || '',
        "gender": obj.gender || '',
        "subjects": [
            // "物理",
            // "化学",
            // "生物"
        ],
        "subjects_str": obj.subjects_str || '',
        "short_subjects_str": obj.short_subjects_str || '',
        "school_name": obj.school_name || '',
        "provinceId": obj?.provinceId || '',
        "province_name": obj.province_name || '',
        "address": obj.address || '',
        "city": obj.city || '',
        "precedence_type": obj?.precedence_type || '',
        "full_address": obj.full_address || '',
        "classes": obj.classes || '',
        "year": obj.year || null,
        "classId": obj?.classId || '',
        "subject_one": obj?.subject_one || '',
        "subject_two": obj?.subject_two || '',
        "subject_three": obj?.subject_three || '',
        "xuanke": obj.xuanke || '',
        "is_vip": obj.is_vip || '',
        "level_name": obj.level_name || '',
        "vip_level": obj?.vip_level || '',
        "submit_times": obj.submit_times || '',
        "majors": [
            // 4,
            // 3,
            // 1
        ],
        "expires_in": obj.expires_in || '',
        "vipExpiresIn": obj?.vipExpiresIn || '',
        "modify_score_times": obj?.modify_score_times || '',
        "final_mod_score_deadline": obj.final_mod_score_deadline || '',
        "detailed_info_times": obj.detailed_info_times || '',
        "subject_one_score": obj?.subject_one_score || '',
        "subject_two_score": obj?.subject_two_score || '',
        "subject_three_score": obj?.subject_three_score || '',
        "math_score": obj?.math_score || '',
        "chinese_score": obj.chinese_score || '',
        "english_score": obj.english_score || '',
        memberId: obj?.memberId || '',
    }
    return obj
}
export const getUserBaseInfo = (isJson = false) => {
    return new Promise((resolve,reject) => {
        if (!localStorage.getItem('jwt')){
            reject()
            return
        }
        const provinceId = localStorage.getItem('provinceId')
        request.post({url: api.user.info}).then(res => {
            const userInfo = useInfoStore()
            const a = JSON.parse(res)
            if(!a.hasOwnProperty('precedence_type')){
                a.precedence_type = 1
            }
            if (!a.hasOwnProperty('classId')){
                a.classId = 1
            }
            userInfo.setKey('baseInfo', a)
            localStorage.setItem('baseInfo', JSON.stringify(a))

            if (a?.provinceId != provinceId && a?.provinceId) {
                localStorage.setItem('provinceId', a?.provinceId)
                const arr = [ getUserPower(a), getProvinceOssListApi(a?.provinceId)]
                Promise.allSettled(arr).then(r=>{
                    resolve({
                        data: {data: isJson ? JSON.stringify(MappingBaseInfoKey(a)) : MappingBaseInfoKey(a)},
                    })
                })
                return
            }
            resolve({
                data: {data: isJson ? JSON.stringify(MappingBaseInfoKey(a)) : MappingBaseInfoKey(a)},
            })
        }).catch(err => reject())
    })
}
export const getUserPower = async (baseInfo={}) => {
    try {
        const jsonObj = useJsonStore()
        const {agent_power, teacher_power, user_power} = jsonObj.getOssList
        const arr = [
            teacher_power.replace('placeholder', baseInfo.teacher_code),
            agent_power.replace('placeholder', baseInfo.agent_id),
            teacher_power.replace('placeholder', baseInfo.teacher_id),
            teacher_power.replace('placeholder', baseInfo.private_teacher_id),
            user_power.replace('placeholder', baseInfo.userId),
        ]
        const res = await getVolunteerPermissions(arr)
        const result = res?.data || {'show_major_label': 1, 'submit_report': 1}
        jsonObj.setKey('userPower', result)
        return result
    }catch (e) {
    }

}

export const ossListArr = [
   // 'oss.shudaozaixian.com',
   'oss1.shudaozaixian.com',
   'oss2.shudaozaixian.com',
    'oss3.shudaozaixian.com',
    'oss4.shudaozaixian.com',
    'oss5.shudaozaixian.com',
]
const getNumIndex = (min,max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min
}
export const getJsonData = ({url, isTimeStr = true, placeData = [], replace = '',needLoading=true} = {}) => {
    if (replace) {//说明需要执行替换逻辑
        url = url.replace('placeholder', placeData.join(replace))
    }
    url = setJsonUrl(url)
    let baseUrl = (url&&needAllIn.some(i=>url.includes(i)))?process.env.VITE_API_BASE_JSON2:process.env.VITE_API_BASE_JSON
    // if (url&&(url.includes('cache/v.json')||url.includes('cache/notice'))){
    //     baseUrl = process.env.VITE_API_BASE_JSON3
    // }
    if (baseUrl&&baseUrl.includes('oss.shudaozaixian.com')){
        let localUrl = localStorage.getItem('localUrl')
        if (localUrl == 'oss.shudaozaixian.com'){
            localStorage.removeItem('localUrl')
            localUrl = ''
        }
        if (!localUrl){
            const str= ossListArr[getNumIndex(0,ossListArr.length-1)] || ossListArr[0]
            localStorage.setItem('localUrl', str)
            localUrl = str
        }
        if (ossListArr.includes(localUrl)){
            baseUrl = baseUrl.replace('oss.shudaozaixian.com', localUrl)
        }
    }
    return new Promise((resolve,reject) => {
        httpJson.request({
            url: `${baseUrl}${url.replace(process.env.VITE_API_BASE_JSON,'')}`,
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
            },
            needLoading: needLoading || '',
        }).then((res) => {
            if (res?.status === 200) {
                resolve(res.data)
            }
        }).catch(err => {
            reject()
        }).finally(() => {

        });
    })
}
/**
 * 请求ossList中的url
 * @returns {Promise<unknown>}
 */
export const getApiByOssList = (obj = {key: ''}) => {
    return new Promise(resolve => {
        const JsonObj = useJsonStore()
        const url = JsonObj?.ossList?.[obj.key]
        if (url) {
            obj.url = url
            getJsonData(obj).then(res => {
                resolve(res)
            }).catch(err=>{
            })
        }
    })
}
/**
 * 请求ossList中的url传入数组
 * @returns {Promise<unknown>}
 * key replace placeData
 */
export const getApiByArrOssList = (arr= []) => {
    return new Promise(resolve => {
        const JsonObj = useJsonStore()
        const newArr = arr.filter(i=>JsonObj?.ossList?.[i.key]).map((i) => {
            return {
                data: ()=>getJsonData({url:JsonObj.ossList[i.key],replace: i.replace,placeData:i.placeData}),
                key: i.key,
            }
        })
        Promise.allSettled(newArr.map(i=>i.data())).then((res)=> {
            const data = res.map((j,k)=>{
                return {
                    key: arr[k].key,
                    data: j.status === 'fulfilled'? j.value: null
                }
            })
            const obj = {}
            data.filter(i=>i.data).forEach((i) => {
                obj[i.key] = i.data
            })
            resolve(obj)
        })
    })
}

export const getConfigApi = (domain) => {
    return new Promise(resolve => {
        const jsonObj = useJsonStore()
        if (jsonObj.config){
            resolve(jsonObj.config)
            return
        }
        const agentId = sessionStorage.getItem('domain') || domain
        getJsonData({url: `cache/agent_cms_info/data/${agentId}/config`}).then(res => {
            jsonObj.setKey('config',res)
            resolve(res)
        })
    })
}
export const getDomainApi = () => {
    return new Promise(resolve => {
        const jsonObj = useJsonStore()
        if (jsonObj.domainData){
            resolve(jsonObj.domainData)
            return
        }
        let local = new URL(window.location.href)
        getJsonData({url: `cache/agent_cms_info/list/${local.hostname}`}).then(res => {
            sessionStorage.setItem('domain', res.domain)
            localStorage.setItem('domain', res.domain)
            jsonObj.setKey('domainData',res)
            resolve(res)
        })
    })

}
export const getOssListApi = async () => {
    return new Promise(resolve => {
        const jsonObj = useJsonStore()
        if (jsonObj.ossList){
            resolve(jsonObj.ossList)
            return
        }
        getJsonData({url: 'cache/list'}).then(res => {
            jsonObj.setKey('ossList',res)
            resolve(res)
        })
    })
}
export const getProvinceOssListApi = async (provinceId='') => {
    return new Promise(resolve => {
        const jsonObj = useJsonStore()
        // if (jsonObj.provinceOssList){
        //     resolve(jsonObj.provinceOssList)
        //     return
        // }
        const id = provinceId || localStorage.getItem('provinceId')
        if (id && id!=0) {
            getJsonData({
                url: api.oss.sheng_list,
                placeData: provinceId?[provinceId]:[localStorage.getItem('provinceId')],
                replace: '/'
            }).then(res => {
                jsonObj.setKey('provinceOssList',res)
                resolve(res)
            })
        }else {
            resolve()
        }

    })
}
/**
 * 获取小表list
 */
export const getSmallBiao = async ({type='ben',provinceOssList={},batch_id=''}={})=>{
    try {
        const {provinceId,classId} = JSON.parse(localStorage.getItem('baseInfo')||'{}');
        return  await getJsonData({url:provinceOssList.province_plan_score,placeData: [provinceId,batch_id,classId,type],replace:'/'})
    }catch(err){
        return Promise.reject(err);
    }

}
/**
 * 通过schoolid 获取招生计划
 */
export const getEnrollmentPlanBySchoolId = async ({provinceId='',schoolId='',type='ben',batch_id='',provinceOssList={}}={}) => {
    try {
        const small = await getSmallBiao({type,provinceOssList,batch_id});
        const planIdList = small.filter(i=> i.s == schoolId).map(i => i.p);
        if (!planIdList.length) {
            return []
        }
        const year = planIdList[0].toString().substring(0,2)
        const url = provinceOssList[`province_plans_${type}_new_${year}`]
        if (!url){
            return Promise.reject()
        }
        const timeStr = url.split('placeholder_')[1].split('.')[0]
        const arr = planIdList.map((i)=>{
            const replaceStr = CryptoJs.MD5(provinceId+i.toString()+timeStr)
            return getJsonData({url:url.replace(`placeholder_${timeStr}`, replaceStr)})
        })
        const fin = await Promise.all(arr)
        return {arr:fin,planId:planIdList}
    }catch (e) {
        return Promise.reject()
    }
}
/**
 * 获取冲稳保数量
 * @param sheng_oss_list
 * @param lang
 * @param currentScore
 * @param baseInfo
 * @returns {Promise<{count: {wen: number, bao: number, top: number, bottom: number, chong: number}}|{count: {wen: number, bao: number, top: number, bottom: number, chong: number}, newList: *[]}>}
 */
export const searchCWB = async ({sheng_oss_list={},lang=15,currentScore=0,baseInfo= null}={})=>{
    const  count= {
        "top": 0,
        "chong":  0,
        "wen":  0,
        "bao":  0,
        "bottom":  0
    }
     baseInfo = baseInfo || JSON.parse(localStorage.getItem('baseInfo')||'{}')
    try {
        if (baseInfo){
            const province_zhanshi_fangshi =  await getJsonData({url:sheng_oss_list.province_zhanshi_fangshi,needLoading:false})
            const current = Object.entries(province_zhanshi_fangshi).find(i=> i[1].batch_pre == 'ben')
            let batch_id = current?current[1].batch_id:5
            const score = currentScore || baseInfo.score
            let str = baseInfo.provinceId + '/' + baseInfo.classId + '/' + batch_id + '/' + score
            const {qujian} = await getJsonData({url:sheng_oss_list.province_score_toudang_gailv.replace('placeholder', str),needLoading:false})
            let url = sheng_oss_list?.province_plan_score.replace('placeholder', baseInfo.provinceId + '/' + batch_id + '/' + baseInfo.classId + '/' + 'ben')
            let search_plan_list = await getJsonData( {url,needLoading:false})
            const schoolIds = []
            for (let i in search_plan_list) {
                let s = parseInt(search_plan_list[i]['f'])
                if (s > qujian['c']) {
                    count.top += 1
                } else if (s > qujian['w']) {
                    count.chong += 1
                } else if (s > qujian['b']) {
                    count.wen += 1
                    schoolIds.push({
                        s:search_plan_list[i]['s'],
                        score:search_plan_list[i]['score']
                    })
                } else if (s > qujian['d']) {
                    count.bao += 1
                } else {
                    count.bottom += 1
                }
            }
            const newList = schoolIds.map(item => item.s) // 获取所有 id
                .map((s, index, final) => final.indexOf(s) === index && schoolIds[index]) // 保留第一个出现的对象
                .filter(Boolean).sort((a,b)=>b.score-a.score)
            return {count, newList: (lang==15 ? newList.slice(0,15) : newList)}
        }else {
            return {count}
        }
    }catch(err){
        return {count}
    }
}
export const fetchRequest = async (url, options = {}) => {
    const {
        method = 'GET', // 默认请求方法为 GET
        headers = {},   // 请求头
        data = null,    // 请求体数据
    } = options;

    // 设置请求头
    const fetchOptions = {
        method,
        headers: {
            'Content-Type': 'application/json', // 默认设置为 JSON 类型
            ...headers, // 合并用户自定义的请求头
        },
        body: data ? JSON.stringify(data) : null, // 如果有数据则转换为 JSON 字符串
    };
    console.error(fetchOptions,8888)
    try {
        const response = await fetch(process.env.VITE_API_PHP_URL+url, fetchOptions);

        // 检查响应状态
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        // 解析 JSON 响应
        return await response.json();
    } catch (error) {
        console.error('Fetch request failed:', error);
        throw error; // 重新抛出错误
    }
}
